import React from 'react';


const CustomLabel: React.FC<any> = ({   icon , value="", }) => {
  return (
   <div className="row no-gutters"> {icon} <p className="ml-2 mb-1"> {value}</p></div>
  );
};

export default CustomLabel;